// extracted by mini-css-extract-plugin
export default {"profileRoundel":"ProfileRoundel_profileRoundel__bTB0t","label":"ProfileRoundel_label__LOYte"};